import styled, { css } from 'styled-components';
import { Breakpoints } from '../../styled/constants';

export const HeaderWrapperBlock = styled.div<{
  $isSearchPage: boolean;
  $isAdCreateEditPage: boolean;
}>`
  margin-top: 3px;
  ${({ $isSearchPage, $isCurrentItemPage }) =>
    ($isSearchPage || $isCurrentItemPage) &&
    css`
      ${$isSearchPage &&
      css`
        background-color: ${({ theme }) => theme.colors.background.primary};
        height: 60px;
      `};
    `};

  ${({
    $isSearchPage,
    $isAdCreateEditPage,
    $isCurrentItemPage,
    theme,
    $hideMobileHeader
  }) =>
    ($isSearchPage ||
      $isAdCreateEditPage ||
      $isCurrentItemPage ||
      $hideMobileHeader) &&
    css`
      > header {
        display: none;
      }

      @media screen and (min-width: ${$isSearchPage
          ? theme.tabletBreakpoint
          : `${Breakpoints.tablet}px`}) {
        > header {
          display: flex;
        }
        height: max-content;
      }
    `}

  ${({ $hideMobileHeader }) =>
    $hideMobileHeader &&
    css`
      @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
        display: none;
      }
    `}
`;
